import Vue from 'vue';
import Vuex, { createLogger } from 'vuex';
const debug = process.env.NODE_ENV !== 'production';
import user from './modules/user';
import event from './modules/event';
import { createModule } from 'vuex-toast';
import 'vuex-toast/dist/vuex-toast.css';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    event,
    user,
    toast: createModule({
      dismissInterval: 8000,
    }),
  },
  //strict: debug,
  plugins: debug ? [createLogger()] : [],
});
